import React, { useCallback } from 'react'
import { Box, Typography } from '@mui/material'
import { Button, Icon, theme } from '@ketch-com/deck'
import { useIsPermitted } from 'utils/hooks'
import { PERMISSIONS } from 'interfaces/permissions/permissions'
import { useExternalAssessmentResponse } from '../context/ExternalAssessmentResponseContext'

export const ExternalCompletedQuestionActions: React.FC<{}> = () => {
  const { block, isCompleted, isCompletedButStillWorking, uncomplete, refetchAssessments } =
    useExternalAssessmentResponse()
  const handleUncomplete = useCallback(async () => {
    await uncomplete()
    refetchAssessments()
  }, [uncomplete, refetchAssessments])

  const { isPermitted } = useIsPermitted()
  const isPermittedToRespond = isPermitted([PERMISSIONS.ASSESSMENT_RESPOND])

  const completedByName = block.completedByDisplayName || 'Unknown User'

  const helperText = isCompleted ? (
    <Typography variant="smallBody" color="darkDuskFaded.main" component="div" mt={0.25}>
      Completed by&nbsp;
      <Typography variant="smallLabel">{completedByName}</Typography>
    </Typography>
  ) : null

  return (
    <Box display="flex" gap={2} alignItems="center">
      {helperText}
      {isCompleted ? (
        <Box display="inline-flex" alignItems="center" gap={0.75}>
          <Icon name="FCheckRound" iconColor={theme.palette.greenHaze.main} />
          <Typography color="greenHaze.main" variant="label">
            Completed
          </Typography>
          {isPermittedToRespond && isCompletedButStillWorking ? (
            <Button sx={{ ml: 1 }} color="tertiary" onClick={handleUncomplete}>
              Edit
            </Button>
          ) : null}
        </Box>
      ) : null}
    </Box>
  )
}
